module.exports = __webpack_public_path__ + "img/home_download_googleplay.934da7c2.png";